var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavechanges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_13386",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.686,
    y: 14.0376,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_13386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.186 22.2043V36.2043C38.186 36.8459 37.9576 37.3952 37.5006 37.8522C37.0437 38.3091 36.4944 38.5376 35.8527 38.5376H19.5194C18.8777 38.5376 18.3284 38.3091 17.8715 37.8522C17.4145 37.3952 17.186 36.8459 17.186 36.2043V19.8709C17.186 19.2293 17.4145 18.68 17.8715 18.223C18.3284 17.7661 18.8777 17.5376 19.5194 17.5376H33.5194L38.186 22.2043ZM35.8527 23.1959L32.5277 19.8709H19.5194V36.2043H35.8527V23.1959ZM27.686 35.0376C28.6583 35.0376 29.4846 34.6973 30.1652 34.0168C30.8458 33.3362 31.186 32.5098 31.186 31.5376C31.186 30.5654 30.8458 29.739 30.1652 29.0584C29.4846 28.3779 28.6583 28.0376 27.686 28.0376C26.7138 28.0376 25.8874 28.3779 25.2069 29.0584C24.5263 29.739 24.186 30.5654 24.186 31.5376C24.186 32.5098 24.5263 33.3362 25.2069 34.0168C25.8874 34.6973 26.7138 35.0376 27.686 35.0376ZM20.686 25.7043H31.186V21.0376H20.686V25.7043Z",
    fill: "#4928FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavechanges);
export default __webpack_public_path__ + "static/media/save changes.c3632743f88d8613641a2712517ecb8b.svg";
export { ForwardRef as ReactComponent };